<template>
  <div class="m-collapse-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    leaveOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      children: [],
    }
  },
  provide() {
    return {
      register: (field) => {
        this.children.push(field)
      },
      unregister: (field) => {
        this.children.splice(this.children.indexOf(field), 1)
      },
      collapseChange: (field) => {
        if (this.leaveOpen) {
          return
        }

        this.children.map((child) => {
          if (child != field) {
            child.close()
          }
        })
      },
    }
  },
}
</script>
